/**
 * Gerador de CSV modelo para importação de CLIENTES.
 *
 * Cabeçalhos em pt-BR alinhados ao AUTODETECT de
 * src/components/crm/customers-import/steps/types.ts e 1:1 com os campos
 * do formulário de cadastro de cliente (CustomerFormDialog).
 *
 * Campos obrigatórios: nome, telefone, (cpf OU cnpj).
 *
 * RELEASE:
 *   2026-08-23 v2.0.0 - Modelo completo: adiciona nome_fantasia, data_nascimento,
 *     logradouro, numero, complemento e bairro (antes só existia "endereco",
 *     que era descartado silenciosamente pelo worker).
 *   2026-05-17 v1.0.0 - Versão inicial (Fase 2)
 */

function csvEscape(value: unknown): string {
  const s = value == null ? '' : String(value);
  return /[",\n;]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function buildSampleCustomersCsv(): Blob {
  // Ordem espelha o formulário de cliente: identificação → documentos → endereço → obs.
  const headers = [
    'nome',
    'razao_social',
    'nome_fantasia',
    'telefone',
    'email',
    'cpf',
    'cnpj',
    'data_nascimento',
    'cep',
    'logradouro',
    'numero',
    'complemento',
    'bairro',
    'cidade',
    'estado',
    'observacao',
  ];

  const rows: string[][] = [
    // PF completo
    [
      'João Silva',
      '',
      '',
      '11987654321',
      'joao@exemplo.com',
      '123.456.789-09',
      '',
      '15/03/1985',
      '01310-100',
      'Rua das Flores',
      '100',
      'Apto 42',
      'Bela Vista',
      'São Paulo',
      'SP',
      'Cliente preferencial — recompra mensal',
    ],
    // PJ completo
    [
      '',
      'ACME Tecnologia LTDA',
      'ACME Tech',
      '11933334444',
      'contato@acme.com.br',
      '',
      '12.345.678/0001-95',
      '',
      '01310-100',
      'Av. Paulista',
      '1000',
      'Conj. 12',
      'Bela Vista',
      'São Paulo',
      'SP',
      'Contrato anual',
    ],
    // Mínimo obrigatório (nome + telefone + cpf)
    [
      'Maria Souza',
      '',
      '',
      '+55 21 9 9988-7766',
      'maria@exemplo.com',
      '987.654.321-00',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      'Rio de Janeiro',
      'RJ',
      '',
    ],
  ];

  const lines = [
    headers.join(';'),
    ...rows.map((r) => r.map(csvEscape).join(';')),
  ];

  return new Blob([`\uFEFF${lines.join('\n')}`], {
    type: 'text/csv;charset=utf-8',
  });
}

export function downloadSampleCustomersCsv(filename = 'modelo-importacao-clientes.csv') {
  const blob = buildSampleCustomersCsv();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
